export type FileViewerMode =
  | "default"
  | "analyze"
  | "promote"
  | "adjustPoints"
  | "summaryShare"
  | "annotate"
  | "extract";

/** Modes that morph the FileDetailModal shell to near-fullscreen. */
export const FOCUSED_WORKSPACE_MODES = [
  "promote",
  "analyze",
  "adjustPoints",
] as const satisfies ReadonlyArray<FileViewerMode>;

export type FocusedWorkspaceMode = (typeof FOCUSED_WORKSPACE_MODES)[number];

export function isFocusedWorkspaceMode(
  mode: FileViewerMode,
  isAnalyzePanelDetached = false,
): boolean {
  if (!(FOCUSED_WORKSPACE_MODES as readonly FileViewerMode[]).includes(mode)) {
    return false;
  }
  // Detached analyze returns the rail to Details — keep the shell compact.
  if (mode === "analyze" && isAnalyzePanelDetached) {
    return false;
  }
  return true;
}

/**
 * Prev/next through the file collection is Details-only.
 * Hide overlay arrows and ignore arrow keys while a right-rail feature is open
 * (Promote, Extract, Analyze, Adjust Points, Summary & Share, Annotate).
 * Detached Analyze returns the rail to Details, so navigation stays enabled.
 */
export function canNavigateFileCollection(
  mode: FileViewerMode,
  isAnalyzePanelDetached = false,
): boolean {
  if (mode === "analyze" && isAnalyzePanelDetached) {
    return true;
  }
  return mode === "default";
}
